import { render, staticRenderFns } from "./AsilAlacakKalemiForm.vue?vue&type=template&id=beef84cc"
import script from "./AsilAlacakKalemiForm.vue?vue&type=script&lang=ts"
export * from "./AsilAlacakKalemiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports